import { render, staticRenderFns } from "./PermissionsTree.vue?vue&type=template&id=369f1256&scoped=true"
import script from "./PermissionsTree.vue?vue&type=script&lang=js"
export * from "./PermissionsTree.vue?vue&type=script&lang=js"
import style0 from "./PermissionsTree.vue?vue&type=style&index=0&id=369f1256&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369f1256",
  null
  
)

export default component.exports